import { render, staticRenderFns } from "./vector-list.component.vue?vue&type=template&id=72420f50&"
import script from "./vector-list.component.vue?vue&type=script&lang=js&"
export * from "./vector-list.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports